import React, { useCallback } from "react";

import { useIntl } from "react-intl";

import { Tooltip } from "ds/Tooltip";
import formatValue from "src/organization/pages/project/environment/metrics/utils/formatValue";

import * as S from "../Metric/Metric.styles";
import MetricName from "../Metric/MetricName";
import { ContainerChart } from "../Service.styles";
import { LargeServiceProps } from "../type";

import Skeleton from "./LargeMetric.skeleton";

const LargeMetric = ({
  isLoading,
  activities,
  name,
  onBrush,
  hosts,
  value,
  selectedTimeframe,
  kind,
  serviceKind,
  maxZoom,
  enableOvercommit,
  deployment,
  autoscaleConfig,
  ...props
}: LargeServiceProps) => {
  const intl = useIntl();

  const formatter = useCallback(value => formatValue(name, value), [name]);

  if (isLoading) {
    return (
      <Skeleton
        name={<MetricName name={name} kind={kind} serviceKind={serviceKind} />}
      />
    );
  }
  return value?.length ? (
    <div>
      <S.Layout {...props}>
        <S.Row style={{ flexGrow: 2 }}>
          <MetricName name={name} kind={kind} serviceKind={serviceKind} />
          <div style={{ whiteSpace: "nowrap" }}>
            <S.Value>
              {formatValue(name, value[value.length - 1]["average@value"])}
            </S.Value>
            <S.Max> / {formatValue(name, value[value.length - 1].max)}</S.Max>
          </div>
        </S.Row>
        <S.Row flexEnd>
          <Tooltip
            tooltip={intl.formatMessage({
              id: "metrics.currentaverage"
            })}
            analyticId="metrics.currentaverage"
          >
            <S.Percentage>
              {formatValue("%", value[value.length - 1]["average@percentage"])}
            </S.Percentage>
          </Tooltip>
        </S.Row>
      </S.Layout>
      <ContainerChart
        enableOvercommit={enableOvercommit}
        key={name}
        resourceName={name}
        hosts={hosts}
        data={value}
        max={value[0].max}
        yFormatter={formatter}
        tooltipFormatter={formatter}
        timeframe={selectedTimeframe}
        onBrush={onBrush}
        activities={activities}
        serviceKind={serviceKind}
        deployment={deployment}
        maxZoom={maxZoom}
        autoscaleConfig={autoscaleConfig}
      />
    </div>
  ) : null;
};

export default React.memo(LargeMetric);
